import { useEffect, useState } from 'react';
import { Phone, WhatsappLogo } from '@phosphor-icons/react';
import api from '@/lib/api';

export const DEFAULT_SUPPORT_PHONE = '+91 99902 89610';

let cachedPhone = null;

export function useSupportPhone() {
  const [phone, setPhone] = useState(cachedPhone || DEFAULT_SUPPORT_PHONE);
  useEffect(() => {
    if (cachedPhone) return;
    let cancelled = false;
    api.get('/marketing/config')
      .then(r => {
        const p = r.data?.support_phone || DEFAULT_SUPPORT_PHONE;
        cachedPhone = p;
        if (!cancelled) setPhone(p);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return phone;
}

export const telHref = (phone) => `tel:${String(phone || '').replace(/[^+\d]/g, '')}`;

export const whatsappHref = (phone, text = 'Hi SMSuitePro team, I need some help.') =>
  `https://wa.me/${String(phone || '').replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;

export function WhatsAppButton({ phone, className = '', testid = 'whatsapp-help-btn', label = 'Chat on WhatsApp' }) {
  return (
    <a
      href={whatsappHref(phone)}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 rounded-full bg-[#25D366] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#1EBE5A] transition-colors ${className}`}
      data-testid={testid}
    >
      <WhatsappLogo size={15} weight="fill" /> {label}
    </a>
  );
}

export function SupportHelpLine({ className = '', testid = 'support-help-line' }) {
  const phone = useSupportPhone();
  return (
    <div className={`flex flex-col items-center gap-2 text-xs text-[#71717A] ${className}`} data-testid={testid}>
      <div className="flex items-center gap-1.5">
        <Phone size={13} weight="duotone" className="text-[#1E3A8A]" />
        <span>Any help? Please contact</span>
        <a href={telHref(phone)} className="font-semibold text-[#1E3A8A] hover:underline" data-testid={`${testid}-phone`}>{phone}</a>
      </div>
      <WhatsAppButton phone={phone} testid={`${testid}-whatsapp`} />
    </div>
  );
}
